<template>
  <div id="app">
  </div> <router-view />

</template>

<script>

export default {
  name: 'App',
  components: {
  }
};
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: Arial, sans-serif;
  margin: 0px;
}
.no-scroll {
  overflow: hidden !important;
  position: fixed;
  width: 100%;
}
</style>
